import CostCenter from './CostCenterList';
import CostCenterForm from './CostCenterForm';

export const CostCenterRoutes = [
  { path: '/financeiro/centros', component: CostCenter },
  { path: '/financeiro/centros/:id', component: CostCenterForm },
];
